<template>
    <van-overlay :show="visible" z-index="3001" :lock-scroll="false">
        <div class="dialog">
            <div class="title">
                <div class="text">{{ $t('earncash.earncash_exchange') }}</div>
                <div class="close" @click.stop="handleClose"></div>
            </div>
            <div class="content">
                <div class="balance">
                    {{ $t('earncash.earncash_available_2') }}:
                    <span>{{ data.current }}</span>
                </div>
                <div class="input-label">{{ $t('earncash.earncash_exchange_amount') }}</div>
                <div class="number-input">
                    <van-field
                        type="digit"
                        v-model="num"
                        :placeholder="
                            $t('earncash.earncash_exchange_number', {
                                number: data.transConfig.limit,
                            })
                        "
                    />
                </div>
                <div class="tip">{{ $t('earncash.earncash_times', { number: data.transConfig?.flowmult }) }}</div>
                <div class="wrap">
                    <div
                        :class="[
                            'btn',
                            {
                                'opacity-65 pointer-events-none': !num,
                            },
                        ]"
                        @click="handleConfrim"
                    >
                        {{ $t('Confirm') }}
                    </div>
                    <div class="record" @click.stop="showPop = true"><IconFont name="record" /></div>
                </div>
            </div>
        </div>
    </van-overlay>
    <ExchangePop v-model="showPop" />
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ExchangePop from './exchangePop.vue'
import { useBaseStore } from '@/stores'
import { transGold } from '@/api/earnCash'

const props = defineProps({
    data: {
        type: Object,
        default: () => ({}),
    },
})
const emit = defineEmits(['exchangeFinish'])
const store = useBaseStore()
const visible = defineModel()
const i18n = useI18n()
const num = ref('')
const showPop = ref(false)

const handleClose = () => {
    visible.value = false
}
const handleConfrim = async () => {
    const limit = props.data?.transConfig?.limit
    if (props.data.current < num.value) {
        return showFailToast(i18n.t('earncash.earncash_exchange_noenough'))
    }
    if (!num.value || num.value < limit || num.value > props.data.current) {
        return showFailToast(i18n.t('earncash.earncash_incorrect_info', { number: limit }))
    }
    try {
        const res = await transGold({
            amount: +num.value,
        })
        if (res.code === 200) {
            // 提现成功提示
            showSuccessToast(
                i18n.t('earncash.earncash_success_info', {
                    current_type: store.cureencySymbol(),
                    number: num.value,
                })
            )

            // showCongratulation(store.packageReward({ id: 'gold', num: num.value }))
            num.value = ''
            emit('exchangeFinish', res.balance)
        } else {
            // 提现失败提示
            showFailToast(i18n.t('earncash.earncash_risk_info'))
        }
    } catch (e) {
        console.log(e)
        showFailToast(i18n.t('earncash.earncash_risk_info'))
    }
    handleClose()
}
</script>
<style lang="scss" scoped>
.dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    min-height: 626px;
    padding: 0 30px;

    transform: translate3d(-50%, -50%, 0);
    border-radius: 30px;
    background: linear-gradient(#323838, #323838), linear-gradient(#2a2d3b, #2a2d3b);

    .title {
        @apply flex items-center;
        line-height: 104px;
        color: #fff;
        font-size: 36px;
        font-weight: 700;
        .text {
            flex: 1;
            text-align: center;
        }

        .close {
            position: absolute;
            right: 30px;
            width: 64px;
            height: 64px;
            border-radius: 10px;
            background-color: rgb(70, 79, 80, 0.08);
            background-image: url('@/assets/img/icon/com_close.svg');
            filter: brightness(0) invert(1);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 50%;
        }
    }
    .content {
        color: #fff;
        font-size: 30px;
        font-weight: 400;
        .balance {
            @apply flex items-center gap-[5px];
            &::before {
                content: '';
                display: inline-block;
                width: 32px;
                height: 32px;
                background: url('@/assets/img/earn-cash/earn_gold.png') no-repeat;
                background-size: 100% 100%;
            }
            :deep(span) {
                color: #ffea76;
            }
        }
        .input-label {
            margin: 30px 0;
        }
        .number-input {
            :deep(.van-cell) {
                align-items: center;
                margin: 5px 0 30px;
                height: 78px;
                line-height: 78px;
                padding: 0 20px;
                border-radius: 10px;
                border: 2px solid #394143;
                background-color: #292d2e;
                overflow: visible;

                &::after {
                    display: none;
                }

                .van-field__control {
                    caret-color: white; /* 将光标颜色设置为白色 */
                }
                .van-field__body {
                    position: relative;

                    input {
                        font-size: 24px;
                        font-weight: bold;
                        color: #fff;

                        &::placeholder {
                            color: #fff5;
                        }
                    }
                }
            }
        }
        .tip {
            margin-top: 30px;
            color: #8a8e93;
            font-size: 24px;
            font-weight: 400;
        }
        .wrap {
            position: relative;
            .record {
                position: absolute;
                top: 60%;
                right: 80px;
                width: 52px;
                height: 52px;

                transform: translate3d(70px, -60%, 0);

                .anticon {
                    color: #8eaaba;
                    font-size: 50px;
                }
            }
        }
        .btn {
            @apply flex justify-center items-center relative;
            margin: 50px auto 0;
            width: 350px;
            height: 92px;
            background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%), linear-gradient(#8b0500, #8b0500);
            box-shadow: 0 0 0.16rem rgba(35, 238, 136, 0.3), inset 0 -0.05333rem #1dca6a;
            border-radius: 14px;

            color: #000;
            font-size: 44px;
            font-weight: 600;
        }
    }
}
</style>
